
// *** Used to render <Radio> button list in 
// *** data-processing/modules/session-steps/database/DatabaseList.js
/**
 * @param {string} value: used in the submitted JSON
 * @param {string} label: for labeling
 */
export const databaseList = [
  {value: 'mouse', label: 'Mouse Gut Microbiome Database'},
  {value: 'mouseplushost', label: 'Mouse Gut Microbiome Plus Host Database'},
  {value: 'human', label: 'Human Gut Microbiome Database'},
  {value: 'humanplushost', label: 'Human Gut Microbiome Plus Host Database'},
  {value: 'chicken', label: 'Chicken Gut Microbiome Database'},
  {value: 'pig', label: 'Pig Gut Microbiome Database'},
  {value: 'dog', label: 'Dog Gut Microbiome Database'},
  {value: 'rat', label: 'Rat Gut Microbiome Database'},
];